import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=f206d88c&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=f206d88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f206d88c",
  null
  
)

export default component.exports